module.exports = __webpack_public_path__ + "img/img_layout_bg.496a6f85.webp";